import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  addResultadosPromos,
  clearResultadosPromos,
  setCupon,
  setDescuento,
  setDescuentoTotal,
  setPromoMeses,
  updateDescuento,
  updateDomainPromo,
} from "../../globalslice";
import bsqicon from "../../images/cupon-gris.png";
import bsqicon2 from "../../images/cupon-verde.png";
import getCuponInfo from "../../services/CuponInfo";
import { FaSpinner } from "react-icons/fa6";
import { vaciarCupon } from "../hooks/useSetPromoCode";
import { AuthContext } from "../../Auth";

const Coupon = () => {
  const [inputError, setInputError] = useState(false);
  const [icon, setIcon] = useState(bsqicon);
  const [loadingCoupon, setLoadingCoupon] = useState(true);
  const [message, setMessage] = useState(null);
  const [msgresult, setMessageResult] = useState("green");
  const [updateFirstCoupon, setUpdateFirstCoupon] = useState(false);
  const [codeTyping, setCodeTyping] = useState(false);

  const { promoMeses, cupon, resultadosPromos, ResumenData: resumenData, descuento, promoCode } = useSelector((state) => state.global);
  const profile = useSelector((state) => state.profile);
  const { userAuth } = useContext(AuthContext);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    // si carga el componente y existe seleccionado un cupón
    if (descuento && resumenData.length > 0) {
      dispatch(setCupon(descuento));
    } else {
      dispatch(setCupon(""));
    }

    // lo inicializamos en true, para evitar llamadas inecesarias al cargar componentes
    // cambiamos de estatus al loader al cargar componente
    setLoadingCoupon(false);

    // hacemos que al cargar el componente valide el cupon de promociones
    setUpdateFirstCoupon(true);
  }, [dispatch]);

  // asigna un temporizador para eliminar cerrar el mensaje
  useEffect(() => {
    let timer = null;

    if (message) {
      timer = setTimeout(() => setMessage(null), 10000);
    }

    return () => clearTimeout(timer);
  }, [message]);

  // hacemos las acciones necesarias al cambiar agregar promoción correctamente
  useEffect(() => {
    const calcDescPromo = async () => {
      // si el resultado no se obtuvo correctamente o si no contiene una promoción válida
      if (!resultadosPromos?.success || resultadosPromos?.success !== "success") {
        // terminamos proceso
        return;
      }

      // declaración de variables
      let porcentajeDescuento = 0;
      let descuentototalocal = 0;
      let descuentotxt = null;
      let iddesc = null;
      let applyDiscount = false;

      // se recorren los productos agregados al carrito
      await resumenData.forEach((resumen) => {
        Object.entries(resultadosPromos.datos).forEach(([id, descuentof]) => {
          // A cada item tengo que ver si tengo que descontar o agregar leyenda de decuento aplicaddo
          if (parseInt(resumen.id) === parseInt(id)) {
            switch (descuentof.type) {
              case "Percentage":
                porcentajeDescuento = parseFloat(resumen.price.second_price.replace(/,/g, "")) * (parseFloat(descuentof.descuento) / 100);
                descuentototalocal += porcentajeDescuento;
                applyDiscount = true;
                break;

              case "meses":
                descuentotxt = `${descuentof.descuento} Meses adicionales`;
                iddesc = id;
                dispatch(setPromoMeses(true));
                //Agregar mensaje de que se aplico promocion
                dispatch(updateDomainPromo({ id: resumen.id, newPromo: descuentotxt + " " + resultadosPromos.cupon }));
                dispatch(updateDescuento({ iddesc, descuentotxt }));
                applyDiscount = true;
                break;

              case "Fixed Amount":
                descuentototalocal += parseFloat(descuentof.descuento);
                applyDiscount = true;
                break;

              case "Price Override":
                const priceProduct = parseFloat(String(resumen.price.second_price).replaceAll(",", ""));
                const priceDesc = parseFloat(descuentof.descuento);
                descuentototalocal += priceProduct - priceDesc;
                applyDiscount = true;
                break;

              default:
                break;
            }
          }
        });
      });

      // si se aplico un descuento
      if (applyDiscount) {
        // si el descuento no es de meses, actualizamos el monto descuento
        if (descuentototalocal > 0) {
          dispatch(setDescuentoTotal(descuentototalocal));
        }
      } else {
        // si no se aplico ningún descuento
        // reiniciamos los valores de promociones
        handleVaciarCoupon();
        setMessage(null);
      }
    };

    calcDescPromo();
  }, [dispatch, resultadosPromos]);

  // valida el cupon cada vez que se hace un cambio en el ResumenData
  useEffect(() => {
    const verifyCouponOnChangeDataCart = () => {
      const itemsCart = resumenData.filter((item) => !item.actual).length;

      // si el carrito no tiene productos
      if (itemsCart === 0) {
        // terminamos proceso
        return;
      }

      // si se espera respuesta del backend
      if (loadingCoupon) {
        // terminamos proceso
        return;
      }

      // si se tiene aplicada una promoción al carrito actual
      if (resultadosPromos?.datos) {
        // ejecutamos flujo para validar si el cupón es válido con los productos en el carrito
        handleCoupon({ showMessages: false });

        // terminamos proceso
        return;
      }

      // si se tiene una promocion por URL
      if (promoCode) {
        // asignamos el cupon al input
        dispatch(setCupon(promoCode));
      }
    };

    verifyCouponOnChangeDataCart();
  }, [dispatch, resumenData, updateFirstCoupon, promoCode, profile?.name]);

  // se monitorea el cambio en el input de cupon
  useEffect(() => {
    const applyCouponURL = () => {
      // si existe promoción aplicada
      if (resultadosPromos.length > 0) {
        // terminamos proceso
        return;
      }

      // si el código fue ingresado por el usuario
      if (codeTyping) {
        // terminamos proceso
        return;
      }

      // si el cupón en el input no es el mismo que el de la URL
      if (cupon !== promoCode) {
        // terminamos proceso
        return;
      }

      // ejecutamos flujo para validar si el cupón es válido con los productos en el carrito
      handleCoupon({ showMessages: false });
    };

    applyCouponURL();
  }, [cupon]);

  const handleCoupon = async ({ showMessages = true } = {}) => {
    const itemsCart = resumenData.filter((item) => !item.actual).length;
    // si el carrito no tiene productos o esta en espera de respuesta del backend
    if (itemsCart === 0 || loadingCoupon) {
      // terminamos proceso
      return;
    }

    // si el input no contiene caracteres, o solo contiene espacios
    if (cupon.trim() === "") {
      setInputError("red");
      return;
    }

    // reiniciamos states a sus valores por default
    setMessage(null);
    setMessageResult("green");
    setInputError(false);

    try {
      setLoadingCoupon(true);

      const resultados = await getCuponInfo({ cupon, resumenData, profile });

      // borramos los valores de promociones agregados a cada producto
      await resumenData.forEach((resumen) => {
        if (resumen.descuento) {
          dispatch(updateDescuento({ iddesc: resumen.id, descuentotxt: "" }));
          dispatch(updateDomainPromo({ id: resumen.id, newPromo: "" }));
        }
      });

      if (resultados.success === "success") {
        dispatch(addResultadosPromos(resultados));
        dispatch(setDescuento(resultados.cupon));
      } else {
        dispatch(clearResultadosPromos());
        dispatch(setDescuentoTotal(0));
        dispatch(setDescuento(null));

        // si no se muestra error, borramos el input
        if (!showMessages) {
          dispatch(setCupon(""));
        }
      }

      if (showMessages) {
        setMessage(resultados.message);
        setMessageResult(resultados.classerror);
      }
    } catch (error) {
      if (showMessages) {
        setMessageResult("red");
        setMessage("Error al obtener la información del cupón.");
      }
    } finally {
      setLoadingCoupon(false);
    }
  };

  const handleVaciarCoupon = async () => {
    await vaciarCupon({
      dispatch,
      setDescuentoTotal,
      setDescuento,
      addResultadosPromos,
      setCupon,
      setPromoMeses,
      updateDomainPromo,
      promoMeses,
      resumenData,
    });
    setMessage(null);
  };

  return (
    <>
      <div className="input-res-container">
        <img src={`${icon}`} alt="Icon Busqueda" className="res-cupon-icon" />
        <input
          type="text"
          id="res-input-cupon"
          className={`form-control input-res-cupon ${inputError === "red" ? "input-error" : inputError === "green" ? "input-green " : ""}`}
          value={cupon}
          placeholder={t("resumen.content.codigo")}
          onChange={(e) => {
            dispatch(setCupon(e.target.value));
          }}
          onFocus={() => setIcon(bsqicon2)}
          onBlur={() => setIcon(bsqicon)}
          disabled={!!descuento || loadingCoupon}
          onKeyDown={() => {
            // marcamos que el cupón esta siendo ingresado por el usuario en el input
            setCodeTyping(true);
          }}
          onKeyUp={() => {
            // después de un segundo
            setTimeout(() => {
              // marcamos que el cupón no esta siendo ingresado por el usuario
              setCodeTyping(false);
            }, 1_000);
          }}
        />
        <button
          className={`input-button ${descuento ? "btn-red" : "btn-orange"}`}
          onClick={() => {
            if (descuento) {
              handleVaciarCoupon();
            } else {
              handleCoupon();
            }
          }}
          disabled={loadingCoupon}
          style={{ minWidth: "75px" }}
        >
          {loadingCoupon && <FaSpinner className="spinner" />}
          {!loadingCoupon && (descuento ? t("resumen.content.eliminar") : t("resumen.content.aplicar"))}
        </button>
      </div>

      {message && <div className={`bsq-res-error ${msgresult}`}>{message}</div>}
    </>
  );
};

export default Coupon;
